import { render, staticRenderFns } from "./resourceInfo.vue?vue&type=template&id=25a33cca&scoped=true"
import script from "./resourceInfo.vue?vue&type=script&lang=js"
export * from "./resourceInfo.vue?vue&type=script&lang=js"
import style0 from "./resourceInfo.vue?vue&type=style&index=0&id=25a33cca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a33cca",
  null
  
)

export default component.exports